module.exports = __webpack_public_path__ + "static/img/5.970352f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/5.jpg
// module id = pAkR
// module chunks = 0